import React from 'react';
import GameActivitySetUpBase from '../GameActivitySetUpBase';
import {
  wheelOfFortuneActivityJsonSchema,
  wheelOfFortuneActivityUiSchema
} from '@/services/schema/activity';

const WheelOfFortuneSetup = (props) => (
  <GameActivitySetUpBase
    {...props}
    activityJsonSchema={wheelOfFortuneActivityJsonSchema}
    activityUiSchemaFn={wheelOfFortuneActivityUiSchema}
    testId='wheel-of-fortune-activity-card'
  />
);
WheelOfFortuneSetup.displayName = 'WheelOfFortuneSetup';

export default React.memo(WheelOfFortuneSetup);
